import { render, staticRenderFns } from "./article-with-image.vue?vue&type=template&id=1ef74e46"
import script from "./article-with-image.vue?vue&type=script&lang=js"
export * from "./article-with-image.vue?vue&type=script&lang=js"
import style0 from "./article-with-image.vue?vue&type=style&index=0&id=1ef74e46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports